<template>
<div class="inventory-info">
    <div class="main-content-full">
        <div class="controller-container">
            <div class="controller-content">
                <el-select class="action-select-first" @change="selectInventoryClass" v-model="inventoryClassIndex" placeholder="选择直发库">
                    <el-option v-for="(item, index) in inventoryClassArr" :key="index" :label="item.warehouse_name" :value="item.warehouse_id">
                    </el-option>
                </el-select>
                <el-cascader class="action-select-inventory" placeholder="选择经销商仓库" :filterable="true" :clearable="true" :options="oneLevelInventoryArr" v-model="oneLevelInventory" @change="selectOneLevelInventory">
                </el-cascader>
                <el-cascader class="action-select-inventory" placeholder="选择汽服门店仓库" :filterable="true" :clearable="true" :options="twoLevelInventoryArr" v-model="twoLevelInventory" @change="selectTwoLevelInventory">
                </el-cascader>
            </div>
        </div>
        <div class="table-container">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle">
                <el-table-column align="center" prop="classification" label="操作" min-width="13%">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="changeThreshold(scope.$index, tableData)" type="text" size="small">
                            修改阈值
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="name" label="商品名称" min-width="30%">
                    <template slot-scope="scope">
                        <div class="table-product-name">{{scope.row.name}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="current_nums" label="商品库存" min-width="13%">
                </el-table-column>
                <el-table-column align="center" prop="min_nums" label="最低报警阈值" min-width="13%">
                </el-table-column>
                <el-table-column align="center" prop="max_nums" label="最高报警阈值" min-width="13%">
                </el-table-column>
                <el-table-column align="center" prop="status" label="商品库存状态" min-width="13%">
                </el-table-column>
            </el-table>

            <el-dialog title="修改阈值" :visible.sync="dialogFormVisible">
                <el-form :model="form">
                    <el-form-item label="最低阈值" :label-width="formLabelWidth">
                        <el-input v-model="form.min_nums" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="最高阈值" :label-width="formLabelWidth">
                        <el-input v-model="form.max_nums" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="changeThresholdCancel">取 消</el-button>
                    <el-button type="primary" @click="changeThresholdOk(form)">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters,
    mapMutations
} from 'vuex';
export default {
    data() {
        return {
            inventoryClassArr: [],
            inventoryClassIndex: '',
            tableData: [],
            currentWarehouse_id: '',
            oneLevelInventoryArr: [],
            twoLevelInventoryArr: [],
            oneLevelInventory: [],
            twoLevelInventory: [],
            dialogFormVisible: false,
            form: {},
            formTemp: {},
            formLabelWidth: '120px'
        }
    },
    computed: {
        ...mapGetters(['user', 'userTypeNum'])
    },
    created() {
        this.init();
    },
    methods: {
        changeTableHeaderStyle({
            row,
            rowIndex
        }) {
            return 'color:black; font-weight: bold;';
        },
        changeTableStyle({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            if (columnIndex == 5) {
                if (row.status_num == -1) {
                    return 'color: #FF3333;'
                } else if (row.status_num == 0) {
                    return 'color: #29bd7f;'
                } else if (row.status_num == 1) {
                    return 'color: #e6a23c;'
                }
            }
            return 'color: #000;'
        },
        init() {
            this.axios.get('getwarehouse', {
                params: {
                    user_id: this.user.id,
                    type: 1
                }
            })
            .then(res => {
                this.inventoryClassArr = res.data.data;
                this.axios.get('getbranchwarehouse', {
                    params: {
                        user_id: this.user.id,
                        branch_type: 1
                    }
                })
                .then(res => {
                    this.oneLevelInventoryArr = res.data.data;
                    this.axios.get('getbranchwarehouse', {
                        params: {
                            user_id: this.user.id,
                            branch_type: 2
                        }
                    })
                    .then(res => {
                        this.twoLevelInventoryArr = res.data.data;
                        this.currentWarehouse_id = 1;
                        this.getInventoryTableData(this.currentWarehouse_id, 0);
                    })
                })
            })
        },
        getInventoryTableData(warehouse_id, class_id) {
            this.axios.get('obtain_warehouse_info', {
                    params: {
                        warehouse_id: warehouse_id,
                        class_id: class_id
                    }
                })
                .then(res => {
                    this.tableData = res.data.data;
                })
        },
        // 选择直发库
        selectInventoryClass(warehouseId) {
            this.getInventoryTableData(warehouseId, 0)
        },
        // 选择下级仓库结构
        selectOneLevelInventory() {
            this.currentWarehouse_id = this.oneLevelInventory[1];
            this.getInventoryTableData(this.currentWarehouse_id, 0)
        },
        // 选择下2级仓库结构
        selectTwoLevelInventory() {
            this.currentWarehouse_id = this.twoLevelInventory[2];
            this.getInventoryTableData(this.currentWarehouse_id, 0)
        },
        // 修改阈值
        changeThreshold(index, tableData) {
            this.form = tableData[index]
            this.formTemp = Object.assign({}, this.form);
            this.dialogFormVisible = true;
        },
        // 确认修改阈值
        changeThresholdOk (rowData) {
            let params = {
                max_nums: parseFloat(rowData.max_nums),
                min_nums: parseFloat(rowData.min_nums),
                inventory_id: rowData.id
            }
            this.axios.post('/threshold', JSON.stringify(params))
            .then(res => {
                this.dialogFormVisible = false;
                this.$message({
                    message: '修改阈值成功！',
                    type: 'success'
                })
            })
        },
        // 取消修改阈值
        changeThresholdCancel () {
            this.form.min_nums = this.formTemp.min_nums;
            this.form.max_nums = this.formTemp.max_nums;
            this.dialogFormVisible = false;
        }
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);

.inventory-info .controller-container {
    background-color: #d2f5e8;
}

.inventory-info .controller-content {
    width: 90%;
    margin: 0 auto;
}

.action-select-first,
.action-select-inventory {
    margin-left: 24px;
    width: 161px;
}

.action-select-first {
    margin-left: 0px;
}

.table-product-name {
    text-align: left;
    padding-left: 34px;
    color: #46a0fe;
}
</style>



// WEBPACK FOOTER //
// src/pages/inventoryManage/InventoryWarnning.vue